import React, { useState, useEffect, useRef } from "react";

export default function ReadMoreContainer(props: {
  children?: React.ReactNode;
  maxLength: number;
}) {
  const { children, maxLength } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Adjust content height based on whether it's expanded
    if (contentRef.current) {
      contentRef.current.style.maxHeight = isExpanded
        ? "none"
        : `${maxLength * 1.45}rem`;
    }
  }, [isExpanded, maxLength]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="c-read-more-container">
        <div
          id="expandableContent"
          ref={contentRef}
          className={`c-read-more__content ${isExpanded ? "expanded" : ""}`}
        >
          {children}
        </div>
        {!isExpanded ? (
          <div className="c-read-more__overlay" onClick={toggleExpand}>
            <button
              className="btn btn--read-more link-primary"
              onClick={toggleExpand}
              aria-expanded="false"
              aria-controls="expandableContent"
            >
              + Læs mere
            </button>
          </div>
        ) : (
          <button
            className="btn btn--read-more link-primary"
            onClick={toggleExpand}
            aria-expanded="true"
            aria-controls="expandableContent"
          >
            - Læs mindre
          </button>
        )}
      </div>
    </>
  );
}
